import React, { useState, useEffect } from 'react';
import Loader from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import { toastMessage } from '../../utils/toast';
import { apiWrapWithErrorWithData } from '../../utils/apiWrapper';
import { getAllAffiliateAgentById } from '../../Redux/Actions/affiliateAgent';
import { documentDownload } from '../../Redux/Actions/jobs';

const AffiliateAgentInfo = ({ match }) => {
    const [loading, setLoading] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [agentDetails, setAgentDetails] = useState(null);
    const { t } = useTranslation();
    const { id } = match.params;

    useEffect(() => {
        setLoading(true);
        if (id) {
            getAgentDetailByIdApi(id);
        }
    }, [id]);

    const getAgentDetailByIdApi = async (id) => {
        try {
            const response = await apiWrapWithErrorWithData(
                getAllAffiliateAgentById(id)
            );
            setAgentDetails(response?.data);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log("getAgentDetailByIdApi", error);
            toastMessage('error', (error && error.message) || 'Unable to get the data');
        }
    };

    const handleDownloadDocument = async () => {
        setButtonLoading(true)
        try {
            const response = await documentDownload(2,agentDetails.emiratesIdDocumentId);
            let binary_string = window.atob(response.data.content);
            let len = binary_string.length;
            let bytes = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
                bytes[i] = binary_string.charCodeAt(i);
            }
            let blob = new Blob([bytes], { type: response.data.contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = response.data.fileName;
            link.click();
            setButtonLoading(false)
        } catch (error) {
            console.log("handleDownloadDocument", error);
            toastMessage('error', (error && error.message) || 'Unable to get the data');
            setButtonLoading(false)
        }
    }

    return (
        <div className="container-fluid">
            <div className="my-4">
            </div>
            {loading ? <div className="d-flex align-items-center justify-content-center h-75vh"><Loader type="ThreeDots" color="#2d207d" height={40} width={40} style={{ textAlign: 'center' }} /></div>
                : <div>
                    <div className="row col-lg-12">
                        <div className="col-lg-12">
                            <div className="card card-custom card-stretch gutter-b">
                                <div className="card-header border-0 d-flex justify-content-between">
                                    <h3 className="card-title font-weight-bolder text-dark">{t("Info")}</h3>
                                </div>
                                {(agentDetails &&
                                    <div className="card-body pt-0 pb-3">
                                        <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa' }}>
                                            <span className="text-muted">{t("Name")} : </span> {agentDetails.name}
                                        </div>
                                        <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa' }}>
                                            <span className="text-muted">{t("Email")} : </span> {agentDetails.email}
                                        </div>
                                        <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa' }}>
                                            <span className="text-muted">{t("Mobile Number")} : </span> {agentDetails.mobileNumber}
                                        </div>
                                        <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa' }}>
                                            <span className="text-muted">{t("Emirates Id")} : </span> {agentDetails.emiratesId}
                                        </div>
                                        <div className="form-group fv-plugins-icon-container" style={{ marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa' }}>
                                            <span className="text-muted">{t("Status")} : </span> {agentDetails.isActive?"Active":"InActive"}
                                        </div>
                                        <hr className="hr-dashed" />
                                        <div className="form-group fv-plugins-icon-container">
                                            <div className="d-flex justify-content-between">
                                                <h3 className="card-title font-weight-bolder text-dark">{t("Document")}</h3>
                                                {agentDetails.emiratesIdDocumentId ? <button disabled={buttonLoading} className="btn btn-primary d-flex align-items-center" onClick={handleDownloadDocument}>
                                                    {t("Download")}
                                                    {buttonLoading && <Loader type="Oval" color="#fff" height={20} width={20} style={{ marginLeft: '10px' }} />}
                                                </button> : '-'}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};

export default AffiliateAgentInfo;